import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
// import './utils/wdyr';

import ConfigLoader from './components/ConfigLoader';
import LoadingScreen from './components/LoadingScreen';

const container = document.getElementById('root');
const App = React.lazy(() => import('src/App'));

ReactDOM.render(
  <ConfigLoader
    ready={config => {
      return (
        <Suspense fallback={<LoadingScreen />}>
          <App config={config} />
        </Suspense>
      );
    }}
  />,
  container
);
